import React from 'react';
import Loadable from 'react-loadable'

import DefaultLayout from './containers/DefaultLayout';

function Loading() {
  return <div>Loading...</div>;
}

const Dashboard = Loadable({
  loader: () => import('./views/Dashboard/Dashboard'),
  loading: Loading,
});

const Panglima = Loadable({
  loader: () => import('./views/Dashboard/Panglima'),
  loading: Loading,
})

const Alert = Loadable({
  loader: () => import('./views/Dashboard/Alert'),
  loading: Loading,
})

const Approval = Loadable({
  loader: () => import('./views/Dashboard/Approval'),
  loading: Loading,
})

const Unit = Loadable({
  loader: () => import('./views/Unit/Unit'),
  loading: Loading,
})

const Login = Loadable({
  loader: () => import('./views/Users/Login/Login'),
  loading: Loading,
});

const UserManagement = Loadable({
  loader: () => import('./views/Users/Management/Management'),
  loading: Loading,
});

const Personil = Loadable({
  loader: () => import('./views/Users/Personil/Personil'),
  loading: Loading,
})

const Satuan = Loadable({
  loader: () => import('./views/Satuan/Satuan'),
  loading: Loading,
})

const Komponen = Loadable({
  loader: () => import('./views/Komponen/Komponen'),
  loading: Loading,
})

const UnitDetails = Loadable({
  loader: () => import('./views/Unit/UnitDetails'),
  loading: Loading
})

const Penugasan = Loadable({
  loader: () => import('./views/Penugasan/Penugasan'),
  loading: Loading
})

const Logout = Loadable({
  loader: () => import('./views/Users/Logout/Logout'),
  loading: Loading,
})

const ManajemenPersonil = Loadable({
  loader: () => import('./views/Personil/ManajemenPersonil'),
  loading: Loading,
})

const Anggaran = Loadable({
  loader: () => import('./views/Anggaran/Anggaran'),
  loading: Loading,
})

const Laporan = Loadable({
  loader: () => import('./views/Laporan/Report'),
  loading: Loading,
})

// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
const routes = [
  { path: '/', name: 'Home', component: DefaultLayout, exact: true },
  { path: '/dashboard', name: 'Dashboard', component: Dashboard },
  { path: '/panglima', name: 'Dashboard Panglima', component: Panglima },
  { path: '/pengingat', name: 'Pengingat', component: Alert, exact: true },
  { path: '/persetujuan', name: 'Persetujuan', component: Approval, exact: true },

  //Management
  { path: '/unit', name: 'Unit', component: Unit, exact: true },
  { path: '/unit/details/:id', name: 'Detail Unit', component: UnitDetails, exact: true },

  //Satuan
  { path: '/satuan', name: 'Satuan', component: Satuan },

  //Komponent
  { path: '/komponen', name: 'Komponen', component: Komponen },

  //Manajemen Personil
  { path: '/manajemenpersonil', name: 'Manajemen Personil', component: ManajemenPersonil },

  { path: '/penugasan', name: 'Penugasan', component: Penugasan },

  //User Management
  { path: '/login', name: 'Login', component: Login },
  { path: '/keluar', name: 'Logout', component: Logout },
  { path: '/user/management', name: 'User Management', component: UserManagement },
  { path: '/profil', name: 'Profil Pengguna', component: Personil },

  //Laporan
  { path: '/anggaran', name: 'Anggaran', component: Anggaran },
  { path: '/laporan', name: 'Laporan', component: Laporan },

];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js